import { render, staticRenderFns } from "./TextButton.vue?vue&type=template&id=a83b118a&scoped=true"
import script from "./TextButton.vue?vue&type=script&lang=js"
export * from "./TextButton.vue?vue&type=script&lang=js"
import style0 from "./TextButton.vue?vue&type=style&index=0&id=a83b118a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83b118a",
  null
  
)

export default component.exports